import React from 'react';
import PropTypes from 'prop-types';
//
import { createGlobalStyle } from 'styled-components';
import 'flexboxgrid';

const GlobalStyles = createGlobalStyle`

* {
  -webkit-font-smoothing: subpixel-antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  font-smooth: subpixel-antialiased !important;
  font-family: 'Ubuntu', sans-serif;
  text-rendering: optimizeSpeed !important;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body,
h1,
h2,
h3,
h4,
p,
ul[class],
ol[class],
figure,
blockquote,
dl,
dd {
  margin: 0;
}

html {
  scroll-behavior: smooth;
}

body {
  min-height: 100vh;
}

ul[class],
ol[class] {
  list-style: none;
  padding: 0;
}

img {
  max-width: 100%;
  display: block;
}

article > * + * {
  margin-top: 1em;
}

input,
button,
textarea,
select {
  font: inherit;
}

img:not([alt]) {
  filter: blur(10px);
}

@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

*:focus {
  outline: 0;
}

// Non - reset
@media screen and (min-width: 769px) {
  .hide-on-desktop {display: none;}
}
@media screen and (max-width: 768px) {
  .hide-on-mobile {display: none;}
}

.swiper-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.bg-gray-page {
  background-color: #f3f3f3;
}

.none-underline {
  text-decoration: none;
  display: inherit;
}

.bullet-red {
  span {
    padding-left: 5px;
  }

  &::before {
    font-size: 24px;
    content: "•";
    color: red;
  }
}

.line-height26 {
  line-height: 26px
}

.text-normal {
  font-weight: 300;
}

.text-bold {
  font-weight: bold;
}

.text-bolder {
  font-weight: bolder;
}

.text-xsmall {
  font-size: 12px;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 16px;
}

.white {
  color: #fff
}

.dark-grey {
  color: #646569
}

.red {
  color: #F42534;
}

.p-0 {
  padding: 0 !important;
}

.p-10 {
  padding: 10px;
}

.pt-2 {
  padding-top: 4px;
}

.px-0 {
  padding-right: 0;
  padding-left: 0;
}

.pl-35 {
  padding-left: 34px
}

.m-0 {
  margin: 0 !important
}

.ml-2 {
  margin-left: 4px;
}

.ml-4 {
  margin-left: 8px;
}

.mr-2 {
  margin-right: 4px;
}

.mr-4 {
  margin-right: 8px;
}

.mr-6 {
  margin-right: 12px;
}

.mr-8 {
  margin-right: 16px;
}

.mr-12 {
  margin-right: 25px;
}

.mh-7 {
  margin-left: 7px;
  margin-right: 7px;
}

.mv-7 {
  margin-bottom: 7px;
  margin-top: 7px;
}

.mv-10 {
  margin-bottom: 10px;
  margin-top: 10px;
}

.mv-18 {
  margin-bottom: 18px;
  margin-top: 18px;
}

.h-100 {
  height: 100%;
}
.container-passCoopeuch{
  width: 100%;
    margin-right: auto;
    margin-left: auto;
  }

.success-text {
  color: #0E891A !important;
}
`;

const Theme = ({ children }) => (
  <>
    <GlobalStyles />
    {children}
  </>
);

Theme.propTypes = {
  children: PropTypes.node,
};

Theme.defaultProps = {
  children: null,
};

export default Theme;
